"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Username = exports.OrderContent = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../TopAreaBanner/constants");
const OrderContent = exports.OrderContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  textAlign: 'center',
  margin: '0 auto',
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  span: {
    lineHeight: theme.typography.pxToRem(_constants.TOP_AREA_BANNER_HEIGHT),
    textTransform: 'uppercase',
    fontSize: '1rem'
  },
  svg: {
    height: '2rem'
  },
  'svg:first-of-type': {
    marginRight: theme.spacing(1)
  },
  'svg:last-of-type': {
    marginLeft: theme.spacing(1)
  }
}));
const Username = exports.Username = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textDecoration: 'underline',
  color: theme.palette.common.white,
  marginLeft: theme.spacing(1),
  cursor: 'pointer'
}));
